module.exports = __webpack_public_path__ + "media/assets/cardBookNowSilver-39f74cfe37315b2e8dc096b24a940c44.png";